import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from 'react-router-dom';
import { forgotPasswordInput, type ForgotPasswordInput } from '@portal-leo/shared';
import { Button, Input, Card, CardContent } from '@/components/ui';
import { trpc } from '@/lib/trpc';

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);

  const form = useForm<ForgotPasswordInput>({
    resolver: zodResolver(forgotPasswordInput),
  });

  const mutation = trpc.auth.forgotPassword.useMutation({
    onSuccess: () => setSent(true),
    onError: (err: { message: string }) => {
      form.setError('root', { message: err.message });
    },
  });

  const onSubmit = (data: ForgotPasswordInput) => {
    mutation.mutate(data);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800">
      <Card className="w-full max-w-md">
        <CardContent className="p-8">
          <div className="mb-8 text-center">
            <h1 className="text-2xl font-bold text-primary-600">Portal LEO Clube</h1>
            <p className="mt-2 text-gray-600">Recuperação de senha</p>
          </div>

          {sent ? (
            <div className="space-y-4 text-center">
              <p className="text-green-600 font-medium">
                Se o email estiver cadastrado, você receberá um link para redefinir sua senha.
              </p>
              <p className="text-sm text-gray-600">
                Verifique sua caixa de entrada e a pasta de spam.
              </p>
              <Link
                to="/login"
                className="inline-block text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                Voltar para o login
              </Link>
            </div>
          ) : (
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
              <p className="text-sm text-gray-600">
                Informe seu email cadastrado e enviaremos um link para redefinir sua senha.
              </p>

              <Input
                id="email"
                type="email"
                label="Email"
                placeholder="seu@email.com"
                error={form.formState.errors.email?.message}
                {...form.register('email')}
              />

              {form.formState.errors.root && (
                <p className="text-sm text-red-600">{form.formState.errors.root.message}</p>
              )}

              <Button type="submit" className="w-full" isLoading={mutation.isPending}>
                Enviar link de recuperação
              </Button>

              <p className="text-center text-sm text-gray-600">
                <Link
                  to="/login"
                  className="font-medium text-primary-600 hover:text-primary-700"
                >
                  Voltar para o login
                </Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
